import * as React from "react";
function SvgMenu(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M0 3.2h48v4.5H0V3.2zm0 18.5h48v4.5H0v-4.5zm0 18.6h48v4.5H0v-4.5z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgMenu);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
